import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import * as React from 'react';
import styled from 'styled-components';
const DraggableHandle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  width: 4px;
  padding: 4px 0 0;
  top: 0;
  bottom: 0;
  right: 0;
  cursor: col-resize;
  z-index: var(--zindex-layer-09);
  height: 100%;
  transition: all var(--animation-duration-medium);

  &:hover {
    background-color: var(--blue-50);
    user-select: none;
  }
`;
const Wrapper = styled.div`
  position: relative;
  width: ${(props)=>props.hideContent ? '0px' : `${props.itemWidth}px`};
  height: 100%;
  user-select: none;
  /* Block transitons on width when resizing */
  transition: ${(props)=>props.isResizing && 'width 0s !important'};
`;
export const Resizable = (props)=>{
    const { children, offset, maxWidth, minWidth, disabled = false, initialWidth, hideContent = false, onResizeStart, onResizeStop, onChange, onDoubleClick: onDoubleClickProp, className } = props;
    const [isResizing, setIsResizing] = useState(false);
    const [width, setWidth] = useState(initialWidth);
    // Use refs to store latest values without triggering re-renders
    const widthRef = useRef(width);
    const onChangeRef = useRef(onChange);
    const onResizeStopRef = useRef(onResizeStop);
    useEffect(()=>{
        widthRef.current = width;
    }, [
        width
    ]);
    useEffect(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    useEffect(()=>{
        onResizeStopRef.current = onResizeStop;
    }, [
        onResizeStop
    ]);
    const onMouseDown = ()=>{
        setIsResizing(true);
        onResizeStart === null || onResizeStart === void 0 ? void 0 : onResizeStart(widthRef.current);
    };
    useEffect(()=>{
        setWidth(initialWidth);
    }, [
        initialWidth
    ]);
    const onDoubleClick = ()=>{
        if (onDoubleClickProp) {
            onDoubleClickProp(maxWidth && width < maxWidth ? maxWidth : minWidth && width === maxWidth ? minWidth : width);
            return;
        }
        if (maxWidth && width < maxWidth) {
            setWidth(maxWidth);
            onChange === null || onChange === void 0 ? void 0 : onChange(maxWidth);
            return;
        }
        if (minWidth && width === maxWidth) {
            setWidth(minWidth);
            onChange === null || onChange === void 0 ? void 0 : onChange(minWidth);
        }
    };
    useEffect(()=>{
        const onMouseUp = ()=>{
            var _onResizeStopRef_current;
            setIsResizing(false);
            (_onResizeStopRef_current = onResizeStopRef.current) === null || _onResizeStopRef_current === void 0 ? void 0 : _onResizeStopRef_current.call(onResizeStopRef, widthRef.current);
        };
        const onMouseMove = (e)=>{
            if (isResizing) {
                var _onChangeRef_current;
                const value = Math.min(Math.max(e.clientX - offset + 2, minWidth !== null && minWidth !== void 0 ? minWidth : 0), maxWidth !== null && maxWidth !== void 0 ? maxWidth : Infinity);
                setWidth(()=>{
                    return value;
                });
                (_onChangeRef_current = onChangeRef.current) === null || _onChangeRef_current === void 0 ? void 0 : _onChangeRef_current.call(onChangeRef, value);
            }
        };
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        return ()=>{
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };
    }, [
        isResizing,
        offset,
        minWidth,
        maxWidth
    ]);
    return /*#__PURE__*/ _jsxs(Wrapper, {
        itemWidth: width !== null && width !== void 0 ? width : 256,
        hideContent: hideContent,
        "data-resizing": isResizing,
        isResizing: isResizing,
        className: className ? `${className} resizable-wrapper` : 'resizable-wrapper',
        children: [
            children,
            !disabled ? /*#__PURE__*/ _jsx(DraggableHandle, {
                onMouseDown: onMouseDown,
                onDoubleClick: onDoubleClick
            }) : null
        ]
    });
};
